import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { LectureLecturer } from '../../../../../api/types/lecturers/lectures/lecture-lecturer';
import { startLectureOperation } from '../operations/start-lecture-operation';

interface MyLectureStartDialogProps {
  visible: boolean;
  selectedLecture: LectureLecturer | null;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  onHide: () => void;
}

export const MyLectureStartDialog: React.FC<MyLectureStartDialogProps> = ({
  visible,
  selectedLecture,
  isLoading,
  setIsLoading,
  onHide,
}) => {
  // Handle confirm start lecture
  const handleConfirmStartLecture = async () => {
    if (!selectedLecture) return;

    setIsLoading(true);
    try {
      await startLectureOperation(
        selectedLecture.programId,
        selectedLecture.courseId,
        selectedLecture.id,
      );
      onHide();
    } finally {
      setIsLoading(false);
    }
  };

  // Dialog footer
  const dialogFooter = (
    <div>
      <Button
        label="ביטול"
        icon="pi pi-times"
        onClick={onHide}
        className="p-button-text"
        disabled={isLoading}
      />
      <Button
        label="אישור"
        icon="pi pi-check"
        onClick={handleConfirmStartLecture}
        className="p-button-success"
        loading={isLoading}
        disabled={isLoading}
        autoFocus
      />
    </div>
  );

  return (
    <Dialog
      header="התחלת הרצאה"
      visible={visible}
      style={{ width: '500px' }}
      footer={dialogFooter}
      onHide={() => {
        if (!isLoading) {
          onHide();
        }
      }}
      closable={!isLoading}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <p
          style={{
            fontSize: '1rem',
            color: '#495057',
            fontWeight: 'bold',
          }}
        >
          הינך עומד להתחיל את ההרצאה, האם אתה בטוח?
        </p>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '16px',
            backgroundColor: '#fef3cd',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #ffc107',
          }}
        >
          <i
            className="pi pi-info-circle"
            style={{ fontSize: '1.5rem', color: '#856404', marginTop: '2px' }}
          />
          <p
            style={{
              margin: 0,
              fontSize: '0.95rem',
              color: '#856404',
              lineHeight: '1.5',
            }}
          >
            שים לב, במהלך ההרצאה יש להזין נוכחות ואת נושא המפגש. לא ניתן יהיה
            לסגור הרצאה ללא דיווח נוכחות ו/או שם המפגש.
          </p>
        </div>
      </div>
    </Dialog>
  );
};
